import apiConfig from '../../../config/api'
import {apiRequestorHelper} from '../../../helpers'

export const resetPasswordService = {
  validateToken(token) {
    return apiRequestorHelper({
      url: `${apiConfig.url}/auth/resetPwd/validate?t=${encodeURIComponent(token)}`,
      method: 'get'
    })
  },

  resetPassword(token, newPassword, newPasswordConfirm) {
    return apiRequestorHelper({
      url: `${apiConfig.url}/auth/resetPwd`,
      method: 'post',
      body: {
        token,
        newPassword,
        newPasswordConfirm
      }
    })
  }
}
